export const Info = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="black" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="white" />
      <path
        d="M10.656 5.764V7.18H9.216V5.764H10.656ZM10.68 13.696H12.696V14.5H10.872C9.972 14.5 9.492 13.912 9.492 13.048V9.448H7.176V8.644H10.38V13.36C10.38 13.6 10.476 13.696 10.68 13.696Z"
        fill="white"
      />
    </svg>
  );
};
